import { gql } from '@apollo/client';

export const GET_ROLES_QUERY = gql`
  query getRolesQuery($id: String) {
    roles(id: $id) {
      id
      deleted
      name
    }
  }
`;
